/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import rootReducer from './reducers';
import debounce from 'lodash.debounce';
import {Utils} from './components/Utils';

export const history = createHistory();

const enhancers = [];
const middleware = [
    thunk,
    routerMiddleware(history),
];

// noinspection ES6ModulesDependencies
if (process.env.NODE_ENV === 'development') {
    middleware.push(createLogger());

    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

let initialState = {};
let initLogin = global.localStorage.getItem('login');
if (initLogin) {
    Utils.logobj('STORE', 'initLogin', initLogin);
    initialState.login = JSON.parse(initLogin);
}

const store = createStore(
    rootReducer,
    initialState,
    composedEnhancers
);

store.subscribe(debounce(() => {
    Utils.log('STORE', 'debounced subscribe called');
    global.localStorage.setItem('login', JSON.stringify(store.getState().login));
}, 2000));

export default store;



// WEBPACK FOOTER //
// ./src/store.js